import { IDispatchId } from '../../utils/helpers/redux.helper';
import { ExportTypesEnum } from './export-data.data';

// action payload interfaces
export interface IExportDataPayload extends IDispatchId {
  exportType: ExportTypesEnum;
  companyName: string;
  userEmail: string;
}

export interface IExpenseReportExportDataPayload extends IDispatchId {
  taxYear: number;
}

export interface IExpenseReportExportDataPayload extends IDispatchId {
  userEmail: string;
  taxYear: number;
}

// action enums
export enum ActionsEnum {
  EXPORT_DATA = 'EXPORT_DATA',
  EXPORT_DATA_SUCCESS = 'EXPORT_DATA_SUCCESS',
  EXPORT_DATA_ERROR = 'EXPORT_DATA_ERROR',
  EXPORT_EXPENSE_REPORT_DATA = 'EXPORT_EXPENSE_REPORT_DATA',
  EXPORT_EXPENSE_REPORT_DATA_SUCCESS = 'EXPORT_EXPENSE_REPORT_DATA_SUCCESS',
  EXPORT_EXPENSE_REPORT_DATA_ERROR = 'EXPORT_EXPENSE_REPORT_DATA_ERROR',
}

// action definitions
export interface ExportData {
  type: ActionsEnum.EXPORT_DATA;
  payload: IExportDataPayload;
}

export interface ExportDataSuccess {
  type: ActionsEnum.EXPORT_DATA_SUCCESS;
  payload: IDispatchId;
}

export interface ExportDataError {
  type: ActionsEnum.EXPORT_DATA_ERROR;
  payload: IDispatchId;
}

export interface ExportExpenseReportData {
  type: ActionsEnum.EXPORT_EXPENSE_REPORT_DATA;
  payload: IExpenseReportExportDataPayload;
}

export interface ExportExpenseReportDataSuccess {
  type: ActionsEnum.EXPORT_EXPENSE_REPORT_DATA_SUCCESS;
  payload: IDispatchId;
}

export interface ExportExpenseReportDataError {
  type: ActionsEnum.EXPORT_EXPENSE_REPORT_DATA_ERROR;
  payload: IDispatchId;
}

// action creators
export const exportData = (
  dispatchId: string,
  exportType: ExportTypesEnum,
  userEmail: string,
  companyName: string
): ExportData => ({
  type: ActionsEnum.EXPORT_DATA,
  payload: {
    dispatchId,
    exportType,
    userEmail,
    companyName,
  },
});

export const exportDataSuccess = (dispatchId: string): ExportDataSuccess => ({
  type: ActionsEnum.EXPORT_DATA_SUCCESS,
  payload: {
    dispatchId,
  },
});

export const exportDataError = (dispatchId: string): ExportDataError => ({
  type: ActionsEnum.EXPORT_DATA_ERROR,
  payload: {
    dispatchId,
  },
});

export const exportExpenseReportData = (
  dispatchId: string,
  userEmail: string,
  taxYear: number
): ExportExpenseReportData => ({
  type: ActionsEnum.EXPORT_EXPENSE_REPORT_DATA,
  payload: {
    dispatchId,
    userEmail,
    taxYear,
  },
});

export const exportExpenseReportDataSuccess = (
  dispatchId: string
): ExportExpenseReportDataSuccess => ({
  type: ActionsEnum.EXPORT_EXPENSE_REPORT_DATA_SUCCESS,
  payload: {
    dispatchId,
  },
});

export const exportExpenseReportDataError = (
  dispatchId: string
): ExportExpenseReportDataError => ({
  type: ActionsEnum.EXPORT_EXPENSE_REPORT_DATA_ERROR,
  payload: {
    dispatchId,
  },
});
